module.exports = __webpack_public_path__ + "img/logo_58.0dc6dc66.png";